import { FC } from 'react';
import styles from '../UserInfo.module.scss';

interface UserHeaderProps {
  tribeId: string;
  tribeName: string;
  isLeader: boolean;
}

export const UserHeader: FC<UserHeaderProps> = ({ tribeName }) => {
  return (
    <div className={styles.dataTop}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>{tribeName}</div>
      </div>
    </div>
  );
};
